// extracted by mini-css-extract-plugin
export var callCard = "_r0-0";
export var callMessageButton = "_r0-1";
export var helpIcon = "_r0-3";
export var helpIconContainer = "_r0-4";
export var verticalDivider = "_r0-2";